/*
 * ANTORIS · motor de scroll estilo Apple (tema v54, copia de prueba).
 *
 * Una sola pieza de JS mueve todas las secciones ap-*. Cada sección declara
 * lo que necesita con atributos data-ap-*; aquí no hay nada específico de
 * una sección.
 *
 * OJO con el scroll: en este tema la página NO scrollea en window sino dentro
 * de .page-wrapper (html y body van con overflow hidden). Por eso:
 *   - se escucha 'scroll' en document con capture, que atrapa el scroll de
 *     cualquier contenedor, sea cual sea el que se mueva;
 *   - todas las posiciones salen de getBoundingClientRect(), que es relativa
 *     al viewport y no depende de qué elemento scrollea.
 * Así el motor funciona igual si algún día el tema vuelve a scrollear en window.
 */
(function () {
  if (window.__apCore) return;
  window.__apCore = true;

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  html.classList.add('ap-js');
  if (reduce) html.classList.add('ap-reduce');

  var vh = window.innerHeight;
  var vw = html.clientWidth;
  var clamp = function (v, a, b) {
    return Math.min(b === undefined ? 1 : b, Math.max(a === undefined ? 0 : a, v));
  };
  var isNarrow = function () {
    return window.matchMedia('(max-width: 734px)').matches;
  };

  /* ---------------------------------------------------------------- estado */
  var scenes = [];   // [data-ap-scene] -> escribe --p
  var wordsList = []; // [data-ap-words] -> ilumina palabra por palabra
  var stories = [];  // [data-ap-story] -> paso activo
  var hscrolls = []; // [data-ap-hscroll] -> galería horizontal anclada
  var seen = new WeakSet();

  /* --------------------------------------------------- aparición al entrar */
  var revealIO = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.hasAttribute('data-ap-count')) countUp(e.target);
        revealIO.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
  );

  /* Secciones que oscurecen la página al pasar por el centro (efecto "Pro"). */
  var toneIO = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-toned', e.isIntersecting);
      });
    },
    { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
  );

  /* ------------------------------------------------------------ contadores */
  function formatNum(n, dec) {
    return n.toLocaleString('es-CL', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-to') || el.textContent.replace(/\./g, '').replace(',', '.'));
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    if (isNaN(to)) return;
    if (reduce) {
      el.textContent = formatNum(to, dec);
      return;
    }
    var t0 = null;
    var dur = 1600;
    function step(t) {
      if (!t0) t0 = t;
      var k = clamp((t - t0) / dur);
      var e = k === 1 ? 1 : 1 - Math.pow(2, -10 * k); // easeOutExpo
      el.textContent = formatNum(to * e, dec);
      if (k < 1) requestAnimationFrame(step);
    }
    el.textContent = formatNum(0, dec);
    requestAnimationFrame(step);
  }

  /* --------------------------------------------- texto que se ilumina */
  function splitWords(root) {
    var out = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
            } else {
              var s = document.createElement('span');
              s.className = 'ap-w';
              s.textContent = part;
              frag.appendChild(s);
              out.push(s);
            }
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) {
          walk(n);
        }
      });
    })(root);
    return out;
  }

  /* ------------------------------------------------------ carruseles */
  function initShelf(shelf) {
    var track = shelf.querySelector('[data-ap-track]');
    var prev = shelf.querySelector('[data-ap-prev]');
    var next = shelf.querySelector('[data-ap-next]');
    if (!track) return;

    function stepSize() {
      var items = track.children;
      if (items.length < 2) return track.clientWidth * 0.8;
      var gap = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().right;
      var w = items[0].getBoundingClientRect().width + gap;
      return Math.max(w, Math.floor(track.clientWidth / w) * w);
    }

    /* Puntos bajo el estante (ap-shelfnav): uno por página del carril. Con
       más de 7 páginas (teléfono, 1 tarjeta por página) cada punto agrupa
       varias, para que la píldora no pase del ancho de la pantalla. */
    var dotsBox = shelf.querySelector('[data-ap-dots]');
    var dots = [];
    var group = 1;
    var built = '';

    function buildDots() {
      if (!dotsBox) return;
      var max = track.scrollWidth - track.clientWidth;
      var pages = max > 2 ? Math.ceil(max / stepSize() - 0.05) + 1 : 1;
      group = Math.ceil(pages / 7);
      var n = Math.ceil(pages / group);
      if (built === n + ':' + group) return;
      built = n + ':' + group;
      dotsBox.innerHTML = '';
      dots = [];
      for (var k = 0; k < n; k++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ap-dot';
        b.setAttribute('aria-label', 'Ir a la página ' + (k + 1) + ' de ' + n);
        b.addEventListener('click', (function (page) {
          return function () {
            track.scrollTo({ left: page * stepSize(), behavior: reduce ? 'auto' : 'smooth' });
          };
        })(k * group));
        dotsBox.appendChild(b);
        dots.push(b);
      }
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      shelf.classList.toggle('is-scrollable', max > 2);
      if (!dots.length) return;
      var page = track.scrollLeft >= max ? Infinity : Math.round(track.scrollLeft / stepSize());
      var active = Math.min(dots.length - 1, Math.floor(page / group));
      dots.forEach(function (d, k) {
        d.setAttribute('aria-current', k === active ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -stepSize(), behavior: reduce ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: stepSize(), behavior: reduce ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); sync(); });
    // las fotos cargan después y cambian el ancho del carril
    window.addEventListener('load', function () { buildDots(); sync(); });
    buildDots();
    sync();
  }

  /* ------------------------------ galería "Conoce lo esencial" (autoplay) */
  function initGallery(g) {
    var track = g.querySelector('[data-ap-track]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-ap-slide]'));
    var dots = Array.prototype.slice.call(g.querySelectorAll('[data-ap-dot]'));
    var play = g.querySelector('[data-ap-play]');
    if (!track || !slides.length) return;

    var active = 0;
    var paused = reduce;
    var visible = false;

    function offsetOf(i) {
      return slides[i].offsetLeft - slides[0].offsetLeft;
    }

    function setActive(i) {
      active = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
        // reinicia la barra de progreso del punto activo
        var fill = d.querySelector('.ap-dot__fill');
        if (fill && k === i) {
          fill.style.animation = 'none';
          void fill.offsetWidth;
          fill.style.animation = '';
        }
      });
    }

    function go(i) {
      track.scrollTo({ left: offsetOf(i), behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    }

    function syncPlaying() {
      g.classList.toggle('is-playing', visible && !paused && slides.length > 1);
      if (play) {
        play.setAttribute('aria-label', paused ? 'Reproducir' : 'Pausar');
        play.classList.toggle('is-paused', paused);
      }
    }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); });
      var fill = d.querySelector('.ap-dot__fill');
      if (fill) fill.addEventListener('animationend', function () {
        if (!g.classList.contains('is-playing') || k !== active) return;
        go(active + 1 >= slides.length ? 0 : active + 1);
      });
    });

    if (play) play.addEventListener('click', function () {
      paused = !paused;
      syncPlaying();
    });

    // si el visitante desliza a mano, el punto sigue al slide y se pausa
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var best = 0;
        var bestD = Infinity;
        slides.forEach(function (s, k) {
          var d = Math.abs(track.scrollLeft - offsetOf(k));
          if (d < bestD) { bestD = d; best = k; }
        });
        if (best !== active) setActive(best);
      }, 90);
    }, { passive: true });
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
      track.addEventListener(ev, function () {
        if (!paused) { paused = true; syncPlaying(); }
      }, { passive: true });
    });

    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      syncPlaying();
    }, { threshold: 0.35 }).observe(g);

    setActive(0);
    syncPlaying();
  }

  /* --------------------------------------------------- pantalla TV (ap-tv) */
  /* El video se pide recién al acercarse (data-src) y corre solo mientras se
     ve. Arranca mudo (el navegador no deja autoplay con sonido); "Activar
     sonido" lo reinicia para escuchar la explicación desde el principio.
     Mientras corre:
       - los pasos [data-ap-step-t] se encienden según el segundo del video
         y la línea entre ellos se llena (--f); tocar uno salta a ese segundo;
       - con data-ap-tv-dim la sección "apaga la luz" (.is-dim) y el canvas
         [data-ap-tv-glow] copia el cuadro actual para teñir la pared.
     Un solo requestAnimationFrame hace las dos cosas y se detiene en pausa. */
  function initTv(root) {
    var v = root.querySelector('video');
    if (!v) return;
    var play = root.querySelector('[data-ap-tv-play]');
    var sound = root.querySelector('[data-ap-tv-sound]');
    var soundLabel = root.querySelector('[data-ap-tv-sound-label]');
    var labelOn = soundLabel ? soundLabel.getAttribute('data-on') || soundLabel.textContent : '';
    var stepsBox = root.querySelector('[data-ap-steps]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ap-step-t]'));
    var times = steps.map(function (b) { return parseFloat(b.getAttribute('data-ap-step-t')) || 0; });
    var glow = root.querySelector('[data-ap-tv-glow]');
    var gctx = null;
    try { gctx = glow && glow.getContext ? glow.getContext('2d') : null; } catch (e) {}
    var dimOk = root.hasAttribute('data-ap-tv-dim');
    var loaded = false;
    var visible = false;
    var userPaused = reduce;
    var raf = 0;
    var lastGlow = 0;
    var lastIdx = -2;

    function load() {
      if (loaded) return;
      loaded = true;
      var sm = v.getAttribute('data-src-sm');
      var src = (window.innerWidth < 735 && sm) || v.getAttribute('data-src') || sm;
      if (!src) return;
      v.preload = 'auto';
      v.src = src;
    }
    function start() {
      load();
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }

    function paintSteps() {
      if (!stepsBox || !times.length) return;
      var t = v.currentTime || 0;
      var n = times.length;
      var idx = -1;
      for (var i = 0; i < n; i++) if (t >= times[i]) idx = i;
      var f = 0;
      if (idx >= n - 1) f = 1;
      else if (idx >= 0) f = (idx + clamp((t - times[idx]) / Math.max(0.1, times[idx + 1] - times[idx]))) / (n - 1);
      stepsBox.style.setProperty('--f', f.toFixed(4));
      if (idx === lastIdx) return;
      lastIdx = idx;
      steps.forEach(function (b, k) {
        b.classList.toggle('is-done', k < idx);
        b.classList.toggle('is-active', k === idx);
        if (k === idx) b.setAttribute('aria-current', 'step');
        else b.removeAttribute('aria-current');
      });
    }
    function paintGlow(now) {
      if (!gctx || !root.classList.contains('is-dim') || now - lastGlow < 100) return;
      lastGlow = now;
      // el canvas queda "contaminado" por el video de otro dominio, pero solo
      // se muestra: nunca se leen sus pixeles
      try { gctx.drawImage(v, 0, 0, glow.width, glow.height); } catch (e) {}
    }
    function loop(now) {
      raf = 0;
      paintSteps();
      paintGlow(now || 0);
      if (!v.paused) raf = requestAnimationFrame(loop);
    }

    function sync() {
      var on = !v.paused;
      root.classList.toggle('is-playing', on);
      root.classList.toggle('is-sound', !v.muted);
      root.classList.toggle('is-dim', dimOk && on && visible);
      if (play) play.setAttribute('aria-label', on ? 'Pausar video' : 'Reproducir video');
      if (soundLabel) soundLabel.textContent = v.muted ? labelOn : 'Silenciar';
      if (on && !raf) raf = requestAnimationFrame(loop);
      if (!on) paintSteps();
    }
    function want() {
      if (visible && !userPaused) start();
      else if (!v.paused) v.pause();
      sync();
    }

    new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) load();
    }, { rootMargin: '600px 0px' }).observe(root);
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      want();
    }, { threshold: 0.4 }).observe(root);

    if (play) play.addEventListener('click', function () {
      userPaused = !v.paused;
      if (userPaused) v.pause();
      else start();
    });
    if (sound) sound.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted) {
        userPaused = false;
        try { v.currentTime = 0; } catch (e) {}
        start();
      }
      sync();
    });
    steps.forEach(function (b, k) {
      b.addEventListener('click', function () {
        function go() {
          try { v.currentTime = times[k]; } catch (e) {}
          paintSteps();
        }
        load();
        if (v.readyState >= 1) go();
        else v.addEventListener('loadedmetadata', go, { once: true });
        userPaused = false;
        start();
      });
    });
    ['play', 'pause', 'volumechange'].forEach(function (ev) {
      v.addEventListener(ev, sync);
    });
    v.addEventListener('seeked', paintSteps);
    sync();
  }

  /* ------------------------------------ texto que gira (Rotating Text) */
  /* data-ap-rotate="palabra uno|palabra dos|…" en el párrafo; la caja .ap-rot
     trae la primera palabra en el HTML (así se lee sin JS). Cada palabra se
     arma letra por letra: la que sale sube y se va, la que entra sube desde
     abajo, con un pequeño desfase por letra. Solo gira mientras se ve. */
  function initRotate(el) {
    var box = el.querySelector('.ap-rot');
    var words = (el.getAttribute('data-ap-rotate') || '').split('|')
      .map(function (w) { return w.trim(); })
      .filter(Boolean);
    if (!box || words.length < 2 || reduce) return;

    function build(word) {
      var w = document.createElement('span');
      w.className = 'ap-rot__w';
      Array.prototype.forEach.call(word, function (ch, k) {
        var c = document.createElement('span');
        c.className = 'ap-rot__c';
        c.textContent = ch === ' ' ? ' ' : ch;
        c.style.setProperty('--i', k);
        w.appendChild(c);
      });
      return w;
    }

    var i = 0;
    var cur = build(words[0]);
    cur.classList.add('is-on');
    box.textContent = '';
    box.appendChild(cur);
    box.classList.add('is-live');
    box.style.width = cur.offsetWidth + 'px';

    function next() {
      i = (i + 1) % words.length;
      var nw = build(words[i]);
      box.appendChild(nw);
      box.style.width = nw.offsetWidth + 'px';
      var old = cur;
      old.classList.remove('is-on');
      old.classList.add('is-out');
      nw.getBoundingClientRect(); // que el navegador vea la posición inicial
      nw.classList.add('is-on');
      cur = nw;
      setTimeout(function () {
        if (old.parentNode) old.parentNode.removeChild(old);
      }, 1200);
    }

    var timer = null;
    new IntersectionObserver(function (es) {
      var on = es[0].isIntersecting;
      if (on && !timer) timer = setInterval(next, 2600);
      else if (!on && timer) {
        clearInterval(timer);
        timer = null;
      }
    }).observe(el);
    // si cambian las fuentes o el ancho, la caja se vuelve a medir
    function remeasure() {
      box.style.width = cur.offsetWidth + 'px';
    }
    window.addEventListener('resize', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
  }

  /* ------------------------------------------ cuenta regresiva (ap-cd) */
  /* Cuenta hasta data-end (ISO con zona: 2026-09-30T23:59:59-03:00). El
     último día pasa a data-last-label y al llegar a cero el bloque se
     esconde. Nunca se reinicia: el plazo que muestra es siempre el real.
     Sirve para la sección grande (fichas por unidad) y para la versión
     corta de la ficha de producto (data-mini, un solo texto). */
  var countdowns = [];
  var cdTimer = null;

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function setDigits(box, str) {
    var cur = box.querySelectorAll('.ap-cd__d');
    if (cur.length !== str.length) {
      box.textContent = '';
      for (var i = 0; i < str.length; i++) {
        var d = document.createElement('span');
        d.className = 'ap-cd__d';
        d.textContent = str.charAt(i);
        box.appendChild(d);
      }
      return;
    }
    for (var k = 0; k < str.length; k++) {
      if (cur[k].textContent === str.charAt(k)) continue;
      cur[k].textContent = str.charAt(k);
      if (reduce) continue;
      cur[k].classList.remove('is-tick');
      void cur[k].offsetWidth; // reinicia la animación
      cur[k].classList.add('is-tick');
    }
  }

  function tickCountdowns() {
    var now = Date.now();
    countdowns.forEach(function (c) {
      var left = Math.floor((c.end - now) / 1000);
      if (left <= 0) {
        c.el.hidden = true;
        return;
      }
      var d = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      var lastDay = left < 86400;
      c.el.classList.toggle('is-last', lastDay);
      if (lastDay && c.lastLabel && c.eyebrow && c.eyebrow.textContent !== c.lastLabel) {
        c.eyebrow.textContent = c.lastLabel;
      }
      if (c.mini) {
        if (c.text) c.text.textContent = (lastDay ? '' : d + ' d ') + pad2(h) + ':' + pad2(m) + ':' + pad2(s);
      } else {
        var vals = { d: pad2(d), h: pad2(h), m: pad2(m), s: pad2(s) };
        for (var key in vals) {
          if (c.boxes[key]) setDigits(c.boxes[key], vals[key]);
        }
        if (c.dayLabel) c.dayLabel.textContent = d === 1 ? 'día' : 'días';
      }
      if (c.el.hidden) c.el.hidden = false;
    });
  }

  function initCountdown(el) {
    var end = Date.parse(el.getAttribute('data-end') || '');
    if (isNaN(end)) return;
    var q1 = function (sel) { return el.querySelector(sel); };
    countdowns.push({
      el: el,
      end: end,
      mini: el.hasAttribute('data-mini'),
      lastLabel: el.getAttribute('data-last-label') || '',
      eyebrow: q1('[data-ap-cd-eyebrow]'),
      text: q1('[data-ap-cd-text]'),
      dayLabel: q1('[data-ap-cd-label="d"]'),
      boxes: { d: q1('[data-ap-cd="d"]'), h: q1('[data-ap-cd="h"]'), m: q1('[data-ap-cd="m"]'), s: q1('[data-ap-cd="s"]') }
    });
    tickCountdowns();
    if (!cdTimer) cdTimer = setInterval(tickCountdowns, 1000);
  }

  /* ------------------------------------------------------------- escaneo */
  function scan(root) {
    root = root || document;
    var q = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    // Blur Text: el titular se parte en palabras antes de observarlo
    q('[data-ap-reveal="blur"]').forEach(function (el) {
      if (el.__apSplit) return;
      el.__apSplit = true;
      splitWords(el).forEach(function (w, k) {
        w.className = 'ap-bw';
        w.style.setProperty('--i', k);
      });
    });

    q('[data-ap-reveal], [data-ap-count]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      if (reduce) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-ap-count')) countUp(el);
      } else {
        revealIO.observe(el);
      }
    });

    q('[data-ap-tone]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      toneIO.observe(el);
    });

    q('[data-ap-scene]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      scenes.push({ el: el, mode: el.getAttribute('data-ap-scene') || 'pass', last: -1 });
    });

    q('[data-ap-words]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      wordsList.push({ el: el, words: splitWords(el), last: -1 });
    });

    q('[data-ap-story]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      stories.push({
        el: el,
        steps: Array.prototype.slice.call(el.querySelectorAll('[data-ap-step]')),
        media: Array.prototype.slice.call(el.querySelectorAll('[data-ap-media]')),
        last: -1
      });
    });

    q('[data-ap-hscroll]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      hscrolls.push({ el: el, track: el.querySelector('[data-ap-htrack]'), max: 0 });
    });

    q('[data-ap-shelf]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      initShelf(el);
    });

    q('[data-ap-gallery]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      initGallery(el);
    });

    // el párrafo que gira también lleva data-ap-reveal: marca propia
    q('[data-ap-rotate]').forEach(function (el) {
      if (el.__apRot) return;
      el.__apRot = true;
      initRotate(el);
    });

    q('[data-ap-tv]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      initTv(el);
    });

    q('[data-ap-countdown]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      initCountdown(el);
    });

    measure();
    update();
  }

  /* Alto de las galerías horizontales: el recorrido vertical anclado tiene que
     durar exactamente lo que se desplaza la tira hacia el lado. */
  function measure() {
    vh = window.innerHeight;
    vw = html.clientWidth;
    hscrolls.forEach(function (h) {
      if (!h.track) return;
      var native = isNarrow() || reduce;
      h.el.classList.toggle('is-native', native);
      if (native) {
        h.el.style.height = '';
        h.track.style.transform = '';
        return;
      }
      h.max = Math.max(0, h.track.scrollWidth - vw);
      h.el.style.height = (h.max + vh) + 'px';
    });
  }

  /* --------------------------------------------------------- cuadro a cuadro */
  function progress(rect, mode) {
    switch (mode) {
      case 'pin':
        return clamp(-rect.top / Math.max(1, rect.height - vh));
      case 'exit':
        return clamp(-rect.top / Math.max(1, rect.height));
      case 'enter':
        return clamp((vh - rect.top) / (vh * 0.9));
      default: // 'pass': de que asoma abajo a que sale arriba
        return clamp((vh - rect.top) / (vh + rect.height));
    }
  }

  function onScreen(rect, margin) {
    margin = margin || 0;
    return rect.bottom > -margin && rect.top < vh + margin;
  }

  function update() {
    if (reduce) return;

    scenes.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      if (!onScreen(r, vh * 0.5) && s.last !== -1) return;
      var p = progress(r, s.mode);
      if (Math.abs(p - s.last) < 0.0005) return;
      s.last = p;
      s.el.style.setProperty('--p', p.toFixed(4));
      // pasada la mitad, los botones del primer texto (ya invisible) dejan de
      // recibir clics y los del segundo mensaje empiezan a recibirlos
      s.el.classList.toggle('is-late', p > 0.5);
    });

    wordsList.forEach(function (w) {
      var r = w.el.getBoundingClientRect();
      if (!onScreen(r, vh * 0.3) && w.last !== -1) return;
      // empieza cuando el párrafo asoma al 85% del alto y termina cuando su
      // base cruza la mitad de la pantalla
      var p = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.35));
      if (Math.abs(p - w.last) < 0.001) return;
      w.last = p;
      var n = w.words.length;
      var lit = p * (n + 2) - 1;
      for (var i = 0; i < n; i++) {
        var a = clamp(lit - i);
        var prev = w.words[i].__a;
        if (prev === undefined || Math.abs(prev - a) > 0.01) {
          w.words[i].__a = a;
          w.words[i].style.setProperty('--a', a.toFixed(2));
        }
      }
    });

    stories.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      if (!onScreen(r)) return;
      var idx = 0;
      s.steps.forEach(function (st, k) {
        if (st.getBoundingClientRect().top < vh * 0.55) idx = k;
      });
      if (idx === s.last) return;
      s.last = idx;
      s.el.setAttribute('data-active', idx);
      s.steps.forEach(function (st, k) { st.classList.toggle('is-active', k === idx); });
      s.media.forEach(function (m, k) { m.classList.toggle('is-active', k === idx); });
    });

    hscrolls.forEach(function (h) {
      if (!h.track || h.el.classList.contains('is-native')) return;
      var r = h.el.getBoundingClientRect();
      if (!onScreen(r)) return;
      var p = clamp(-r.top / Math.max(1, r.height - vh));
      h.el.style.setProperty('--p', p.toFixed(4));
      h.track.style.transform = 'translate3d(' + (-p * h.max).toFixed(1) + 'px,0,0)';
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', function () {
    measure();
    scenes.forEach(function (s) { s.last = -1; });
    onScroll();
  });
  window.addEventListener('load', function () {
    measure();
    onScroll();
  });

  /* Anclas #ap-...: el salto nativo no mueve nada porque el que scrollea es
     .page-wrapper (mismo problema que resuelve pf-mobile-fixes para #pf-). */
  function scroller(el) {
    var p = el.parentElement;
    while (p && p !== document.body) {
      var ov = getComputedStyle(p).overflowY;
      if ((ov === 'auto' || ov === 'scroll') && p.scrollHeight > p.clientHeight + 2) return p;
      p = p.parentElement;
    }
    return null;
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="#ap-"]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    var id = href.slice(i + 1);
    var path = href.slice(0, i);
    var t = document.getElementById(id);
    if (!t || (path && path !== '/' && path !== location.pathname)) return;
    ev.preventDefault();
    var c = scroller(t);
    var y = t.getBoundingClientRect().top;
    var behavior = reduce ? 'auto' : 'smooth';
    if (c) c.scrollTo({ top: c.scrollTop + y, behavior: behavior });
    else window.scrollTo({ top: window.scrollY + y, behavior: behavior });
  });

  function boot() {
    scan(document);
    requestAnimationFrame(function () {
      html.classList.add('ap-ready');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // editor de temas: las secciones se vuelven a pintar sin recargar la página
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
